import {Duration} from './Duration';

export class StrokeRate {
    private constructor(public strokesPerMinute: number) {}

    public static fromStrokeCountAndDuration(strokeCount: number, duration: Duration): StrokeRate | null {
        if (duration.seconds === 0 || strokeCount === 0) {
            return null;
        }
        return new StrokeRate(strokeCount / duration.minutes);
    }

    public static fromStrokesPerMinute(strokesPerMinute: number): StrokeRate {
        return new StrokeRate(strokesPerMinute);
    }

    public static average(...strokeRates: StrokeRate[]): StrokeRate | null {
        if (strokeRates.length === 0) {
            return null;
        }
        const totalStrokesPerMinute = strokeRates.reduce((total, strokeRate) => total + strokeRate.strokesPerMinute, 0);
        return StrokeRate.fromStrokesPerMinute(totalStrokesPerMinute / strokeRates.length);
    }
}
